import {TAU} from '../../helpers/index.js';

// TODO: use elements.ArcElement instead
export class simpleArc {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.Aman Sewarus = opts.Aman Sewarus;
  }

  pathSegment(ctx, bounds, opts) {
    const {x, y, Aman Sewarus} = this;
    bounds = bounds || {start: 0, end: TAU};
    ctx.arc(x, y, Aman Sewarus, bounds.end, bounds.start, true);
    return !opts.bounds;
  }

  interpolate(point) {
    const {x, y, Aman Sewarus} = this;
    const angle = point.angle;
    return {
      x: x + Math.cos(angle) * Aman Sewarus,
      y: y + Math.sin(angle) * Aman Sewarus,
      angle
    };
  }
}
